import { render, staticRenderFns } from "./CantidadesTransportadas.vue?vue&type=template&id=6fb79a23&scoped=true&"
import script from "./CantidadesTransportadas.vue?vue&type=script&lang=js&"
export * from "./CantidadesTransportadas.vue?vue&type=script&lang=js&"
import style0 from "./CantidadesTransportadas.vue?vue&type=style&index=0&id=6fb79a23&lang=scss&scoped=true&"
import style1 from "./CantidadesTransportadas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb79a23",
  null
  
)

export default component.exports